import * as React from 'react';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {Illustration} from 'shells/illustrations/illustration';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {useGetDripSequencesDashboard} from '../graphql/hooks';
import {ViewAllLink} from '../view-all-link';

import {DripSequencesTable} from './drip-sequences-table';

type Props = {
    timespan: string;
};

export function DripSequencesCard(props: Props) {
    const {dripSequencesDashboard, isLoading} = useGetDripSequencesDashboard({
        timespan: props.timespan,
    });

    const totalCount = dripSequencesDashboard ? dripSequencesDashboard.totalCount : undefined;
    const stats = dripSequencesDashboard ? dripSequencesDashboard.stats : [];
    const recentDrips = dripSequencesDashboard ? dripSequencesDashboard.recentDrips : [];
    const {onOpen: onOpenDripsModal} = useOpenableModal(OpenableModals.DRIP_SEQUENCE_INFO_MODAL);

    return (
        <DashboardCard
            title='Drip sequences'
            subtitle='Automatically send messages at the right moment'
            link={<ViewAllLink totalCount={totalCount} type='DRIP_SEQUENCES' />}
            isLoading={isLoading}
            mainContent={{
                // @ts-expect-error
                statsProps: {stats, isLoading},
                content: <DripSequencesTable dripSequences={recentDrips || []} />,
            }}
            promoStateOverlay={
                totalCount === 0 ? (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: true,
                            imageComponent: (
                                <Illustration src='trial-onboarding/marketing-drip-sequences' />
                            ),
                            title: 'Automate a series of messages to send at a cadence',
                            subtitle:
                                'A set of messages that automatically send to an audience at set times or after a specific event.',
                            primaryCta: {
                                text: 'Learn more',
                                onClick: onOpenDripsModal,
                            },
                            secondaryCta: {
                                text: 'Create a drip sequence',
                                url: '/email-marketing/drip-sequences?view=board&sort=-modifiedTime',
                            },
                            blueImageBackground: true,
                        }}
                    />
                ) : null
            }
        />
    );
}
